import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { doc, setDoc, collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './config';

const firebaseConfig = {
  apiKey: "AIzaSyCt1B4hlrgSxUp77ay0SWxleFKOnEX8Y68",
  authDomain: "ageizolasyon-b4cef.firebaseapp.com",
  projectId: "ageizolasyon-b4cef",
  storageBucket: "ageizolasyon-b4cef.firebasestorage.app",
  messagingSenderId: "957052971128",
  appId: "1:957052971128:web:e867424a481ba72513a58d",
  measurementId: "G-KLCHXXTG4R"
};

// VAPID Key - Firebase Console > Project Settings > Cloud Messaging > Web Push Certificates
const VAPID_KEY = 'BCMFlGQWeiVC4BO6uNJKOeYxwIELEt-OIHI1otyePQtyolqBOzu-wlivdnORNndAtShdKX-OGuDEYT6dLf2Au2o'; // BUNU DEĞİŞTİR

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

/**
 * Bildirim izni iste ve FCM token al
 * @param {string} ustaId - Ustanın Firestore ID'si
 */
export async function requestNotificationPermission(ustaId) {
  try {
    if (!('Notification' in window)) {
      console.log('Bu tarayıcı bildirim desteklemiyor');
      return null;
    }

    const permission = await Notification.requestPermission();

    if (permission !== 'granted') {
      console.log('Bildirim izni verilmedi');
      return null;
    }

    // Service worker'ı kaydet
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

    // FCM token al
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration
    });

    if (token && ustaId) {
      // Token'ı Firestore'a kaydet
      await setDoc(doc(db, 'ustaTokens', ustaId), {
        token,
        ustaId,
        platform: 'web',
        updatedAt: serverTimestamp()
      }, { merge: true });
    }

    return token;
  } catch (error) {
    console.error('Bildirim izni hatası:', error);
    return null;
  }
}

/**
 * Ön planda gelen bildirimleri dinle
 */
export function onForegroundMessage(callback) {
  return onMessage(messaging, (payload) => {
    console.log('Ön plan bildirimi:', payload);
    callback(payload);
  });
}

/**
 * Ustaya özel bildirim gönder (Admin panelinden çağrılacak)
 * @param {string} ustaId 
 * @param {string} title 
 * @param {string} body 
 * @param {object} data 
 */
export async function sendNotificationToUsta(ustaId, title, body, data = {}) {
  try {
    await addDoc(collection(db, 'bildirimler'), {
      ustaId,
      title,
      body,
      data,
      status: 'pending',
      createdAt: serverTimestamp(),
      createdBy: 'admin'
    });
    return true;
  } catch (error) {
    console.error('Bildirim gönderme hatası:', error);
    return false;
  }
}

/**
 * Tüm aktif ustalara bildirim gönder
 */
export async function sendNotificationToAllUstalar(title, body, data = {}) {
  try {
    await addDoc(collection(db, 'bildirimler'), {
      target: 'all_ustalar',
      title,
      body,
      data,
      status: 'pending',
      createdAt: serverTimestamp(),
      createdBy: 'admin'
    });
    return true;
  } catch (error) {
    console.error('Toplu bildirim hatası:', error);
    return false;
  }
}

export { messaging };